import {useEffect, useState} from "react"
import { GetWindowLanguage } from "../../../helpers/storyHelpers"

const localeToDir = locale => locale === "ar" ? "rtl" : "ltr"

function DocumentDir() {
  const locale = GetWindowLanguage()
  const [dir, setDir] = useState(localeToDir(locale))

  useEffect(() => {
    setDir(localeToDir(locale))
  }, [locale])

  useEffect(() => {
    document.documentElement.setAttribute('dir', dir)
  }, [dir])

  return null
}

export default DocumentDir
